<template>
    <div class="m2 main-container">
        <!-- 跳转 -->
        <div class="zrn-logo"></div>
        <div class="btnlist ">
            <div class="d-flex">
                <div class="NaverLoungeIcon icon-size cursor" @click="NaverLounge_page('naver')"></div>
                <div class="sns icon-size cursor" @click="youtube_page('yt')"></div>
                <div class="share icon-size cursor" @click="fbShare('fb')"></div>
                <div class="zf  cursor" v-if="webpayEnable"></div>

            </div>
        </div>
        <div class="r-icon-link">
            <div class="register  cursor" @click="naver_download('naver')" v-show="loginFlag">
                <!-- <picture class="picture">
                    <source type="image/webp" srcset="../assets/img/common/register.webp" />
                    <img class="image" src="../assets/img/common/register.png" width="100%" />
                </picture> -->
                <img class="image" src="../assets/img/common/register.png" width="100%" />
            </div>
            <!-- <div class="award  cursor" @click="handleTakesPage"></div> -->
        </div>

        <swiper :options="swiperOption" ref="goodSwiper" @slideChange="slideChange">
            <swiper-slide>
                <!-- @handleInvite="handleInvite"  -->
                <slider1 ref="slider1" />
            </swiper-slide>
            <!-- <swiper-slide>
                <slider2 ref="slider2" @handleSilder2Login="handleLoginInfoAgain" :logged="logged"/>
            </swiper-slide> -->
            <swiper-slide>
                <slider3 ref="slider3" />
            </swiper-slide>
            <swiper-slide>
                <slider4 @handlePriseEVent="handlePriseEVent" ref="slider4" @handleEVent="handleEVent"
                    @handleSilder4Login="handleLoginInfoAgain" :mList="mList" :tickets="tickets" />
            </swiper-slide>
            <swiper-slide>
                <slider5 />
            </swiper-slide>
            <swiper-slide>
                <slider6 />
            </swiper-slide>
            <swiper-slide>
                <slider7 />
            </swiper-slide>
            <!-- 最后一页图暂时隐藏 -->
            <swiper-slide>
                <slider8 />
            </swiper-slide>
            <!-- 分页菜单  menuFlag ? 'open' : '',-->
            <div class="swiper-pagination swiper-pagination-home cursor " :class="[
                nextShow ? '' : 'swiperNoSwiping',
                pointEvent ? 'pointEvent' : '',
                paginationIndex > 0 ? 'showPagination' : 'hidePagination'
            ]" slot="pagination"></div>
        </swiper>

        <!-- 点击显示登陆 -->
        <!-- <div class="model position-absolute" v-if="showLogin">
            <div class="r-reg">
                <div class="close cursor" @click="closeLoginModel"></div>
                <div class="r-reg-cnt">
                    <regLogin :isEventPageLogin="false" @handleInfoAgain="handleLoginInfoAgain" />
                </div>
            </div>
        </div> -->
        <!-- 首次登陆的话，弹出确认框 -->

        <div class="model position-absolute" v-if="loginFirst">
            <div class="login-first">
                <div class="close cursor" @click="closeLoginFirstModel"></div>
            </div>
        </div>
    </div>
</template>

<script>
import slider1 from "./publicComponents/slider1";
import slider2 from "./publicComponents/slider2";
import slider3 from "./publicComponents/slider3";
import slider4 from "./publicComponents/slider4";
import slider5 from "./publicComponents/slider5";
import slider6 from "./publicComponents/slider6";
import slider7 from "./publicComponents/slider7";
import slider8 from "./publicComponents/slider8";

import regLogin from './publicComponents/regLogin'

export default {
    name: "Home",
    components: {
        slider1,
        slider2,
        slider3,
        slider4,
        slider5,
        slider6,
        slider7,
        slider8,
        regLogin
    },
    data() {
        return {
            webpayEnable: false,
            logged: false,
            paginationIndex: 0,
            loginFirst: false, // 首次登陆
            tickets: 0,
            mList: [],
            loginFlag: false,
            hasAccount: false,
            // showLogin: false, // 点击显示登陆
            transformStyle: {}, //缩放
            wFlag: false,
            pointEvent: false,
            nextShow: true,
            swiperOption: {
                allowTouchMove: false,
                direction: "vertical", // 滚动方向
                autoHeight: true,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                mousewheel: true, //开启鼠标
                speed: 1100, //滚动速度
                noSwiping: false, //设置轮播图不可滑动
                noSwipingClass: "stop-swiping",
                initialSlide: 0, //轮播图初始索引
                pagination: {
                    el: ".swiper-pagination-home",
                    touchRatio: 1, //解决滑动卡顿
                    longSwipesRatio: 0.1,
                    threshold: 10, //如果触摸距离小于该值滑块不会被拖动
                    followFinger: false,
                    bulletClass: "my-bullet", //需设置.my-bullet样式
                    clickable: true, // 允许点击小圆点跳转
                    autoplayDisableOnInteraction: false,

                    renderBullet: function (index, className) {
                        switch (index) {
                            case 0:
                                name = "";
                                break;
                            case 1:
                                name = "";
                                break;
                            case 2:
                                name = "";
                            case 3:
                                name = "";
                            case 4:
                                name = "";
                            case 5:
                                name = "";
                            case 6:
                                name = "";
                            default:
                                name = "";
                        }
                        return (
                            '<div class="' +
                            className +
                            " " +
                            className +
                            [index] +
                            '"><i>' +
                            name +
                            "</i></div>"
                        );
                    },
                },
                on: {
                    resize: function () {
                        setTimeout(() => {
                            this.update();
                        }, 500); //延时器很重要，不加可能会出错
                    },
                },
            },
            // RegisterSwiperOption: {
            //     direction: "vertical",
            //     nested: true,
            //     slidesPerView: "auto",
            //     freeMode: true,
            //     scrollbar: { el: ".swiper-scrollbar" },
            // },
        };
    },
    created() {
        this.initData();





    },
    updated() { },
    mounted() {
        this.handleTransformStyle();
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };

        // start``````````````````
        let url = window.location.search
        let targetParams = url.indexOf("tag") >= 0 ? this.common.getUrlParam("tag").slice(0, -2) : this.common.getUrlParam("tag")

        if(targetParams === 'mission') {
            this.$refs.goodSwiper.swiper.slideTo(3, 300, true)
        }
        // end

    },
    watch: {},

    methods: {
        slideChange() {
            const mainActiveIndex = this.$refs.goodSwiper.swiper.activeIndex;
            this.paginationIndex = this.$refs.goodSwiper.swiper.activeIndex
            // console.log(this.paginationIndex)

            // || mainActiveIndex === 1
            if (mainActiveIndex === 3 || mainActiveIndex === 1) {
                this.initData();
            }
        },


        naver_download(val) {
            this.common.goStore(val)

        },
        // 点击显示登陆弹出框
        // showLoginBtn() {
        //     this.showLogin = true
            
        // },
        // closeLoginModel() {
        //     this.showLogin = false
        // },
        // 缩放
        handleTransformStyle() {
            this.transformStyle = this.common.handleScale();
        },
        // 点击跳转到
        // handleInvite() {
        //     this.$refs.goodSwiper.swiper.slideTo(1, 300, true);
        // },
        // 点击跳转到活动
        // handleTakesPage() {
        //     this.$refs.goodSwiper.swiper.slideTo(3, 300, true);
        // },
        // 用来控制注册页，在注册的时候，禁止拖动等
        handleEVent(val, index) {
            this.nextShow = val;
            this.swiperOption.mousewheel = val;
            this.swiperOption.noSwiping = true;
            this.$refs.goodSwiper.swiper.destroy(); //先销毁
            this.swiperOption.initialSlide = index;
            this.$refs.goodSwiper.mountInstance(); //后在加载


        },

        // 抽奖后，点击查看奖品列表
        handlePriseEVent(val, index) {
            this.nextShow = val;
            this.swiperOption.mousewheel = val;
            this.swiperOption.noSwiping = true;
            this.$refs.goodSwiper.swiper.destroy(); //先销毁
            this.swiperOption.initialSlide = index;
            this.$refs.goodSwiper.mountInstance(); //后在加载
            // this.initData()
        },
        // 登录成功以后
        handleLoginInfoAgain(isNew) {
            this.loginFlag = false
            this.initData()
            if (isNew === 1) {
                this.loginFirst = true

            } else {
                this.showLogin = false
                setTimeout(() => {
                    this.$refs.goodSwiper.swiper.slideTo(2, 300, true);
                }, 1000)
                this.handleEVent(true, 2)
            }
        },
        // 关闭首次登陆提示窗口
        closeLoginFirstModel() {
            this.loginFirst = false
            this.showLogin = false

            setTimeout(() => {
                this.$refs.goodSwiper.swiper.slideTo(3, 300, true);
            }, 1000)
            this.handleEVent(true, 3)
        },
        // info 接口获取数据
        initData() {
            const reqTime = Math.floor(new Date().getTime() / 1000);
            const account = localStorage.getItem("zero9_account") || 0;


            let url = window.location.search
            let preview = 'unknow';
            let previewParam = url.indexOf("preview") >= 0 ? this.common.getUrlParam("preview").slice(0, -2) : this.common.getUrlParam("preview")
            preview = previewParam || 'unknow';


            this.$axios({
                method: "post",
                url: "qyhx/info",
                data: {
                    //get这里应为params
                    //请求参数
                    signature: this.common.makeSignature({}, reqTime),
                    reqTime: reqTime,
                    // preview: this.common.getUrlParam("preview") || 0, // 测试数据
                    preview: preview,
                    account: localStorage.getItem("zero9_account") ? "010" + account : '',
                },
                //withCredentials:true, //局部携带cookie
                headers: {}, //如果需要添加请求头可在这写
            })
                .then((res) => {
                    //res是返回结果 res.data.data.register
                    if (res.data.code === 0) {

                        if(res.data.data.webpayEnable === 1) {
                            this.webpayEnable  = true
                        }else {
                            this.webpayEnable  = false
                        }
                        this.$nextTick(() => {
                            console.log(res.data.data.webpayEnable)
                        this.$refs.slider1.isWebpayEnable = res.data.data.webpayEnable;

                            this.$refs.slider3.preview = res.data.data.register;
                            this.$refs.slider4.giftList = res.data.data.lotteryItems
                            // this.$refs.slider4.mList = res.data.data.info.missionId
                            // this.$refs.slider4.tickets = res.data.data.info.tickets
                            this.$refs.slider4.invites = res.data.data.info.invites
                            this.$refs.slider4.rewards = res.data.data.info.rewards
                        });

                        setTimeout(() => {
                            this.mList = res.data.data.info.missionId
                            this.tickets = res.data.data.info.tickets

                        }, 200);


                        if (Object.keys(res.data.data.info).length > 0) {
                            this.$refs.slider4.haslogged = true
                            this.logged = true

                            // this.$refs.regLogined.hasAccount = true
                            this.loginFlag = false

                        } else {
                            this.$refs.slider4.haslogged = false
                            this.logged = false

                            // this.hasAccount = false
                            this.loginFlag = true
                        }



                    } else {
                        // this.$refs.slider4.haslogged = false
                    }

                    localStorage.setItem("zero9_tickets", res.data.data.info.tickets);
                    localStorage.setItem("zero9_missionId", res.data.data.info.missionId);
                    localStorage.setItem("zero9_invites", res.data.data.info.invites);
                    localStorage.setItem("zero9_rewards", JSON.stringify(res.data.data.info.rewards));
                    localStorage.setItem("zero9_uuid", res.data.data.info.uuid);


                })
                .catch((err) => {
                    //请求失败就会捕获报错信息
                    //err.response可拿到服务器返回的报错数据
                });

        },

        // 右侧顶部icon 

        NaverLounge_page(val) {
            this.common.goShare(val);

        },
        youtube_page(val) {
            this.common.goShare(val);

        },
        fbShare(val) {
            this.common.doShare(val);
        },
    },
};
</script>
<style lang="scss" >
::-webkit-scrollbar {
    width: 1px;
}

::-webkit-scrollbar-track {
    background-color: transparent;
}

::-webkit-scrollbar-thumb {
    background: transparent;
}


.main-container {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
}

// @-webkit-keyframes pagFadeIn {
//     0% {
//         opacity: 0;
//         /*初始状态 透明度为0*/
//     }

//     50% {
//         opacity: 1;
//         /*中间状态 透明度为1*/
//     }
// }

.showPagination {
    display: block;
   transition: all .3s;
}

.hidePagination {
    display: none;
}



.m2 {
    height: 100%;
    background: #fff;



    .zrn-logo {
        background: url("../assets/img/common/zrn-logo.png") no-repeat;
        background-size: 100% 100%;
        width: 178px;
        height: 60px;
        position: absolute;
        left: 24px;
        top: 24px;
        z-index: 2;
    }

    .login-first {
        background: url("../assets/img/common/login-succ.png") no-repeat center;
        background-size: 100% 100%;
        width: 709px;
        height: 344px;
        position: relative;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .close {
            background: url("../assets/img/common/close-btn.png") no-repeat center;
            background-size: 100% 100%;
            width: 266px;
            height: 70px;
            position: absolute;
            left: 50%;
            top: 199px;
            transform: translate(-50%, 0);
        }
    }

    // 登陆
    .r-reg {
        background: url("../assets/img/common/login/r-reg-bg.png") no-repeat center;
        background-size: 100% 100%;
        width: 1372px;
        height: 760px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .close {
            background: url("../assets/img/common/close.png") no-repeat top;
            background-size: 100% 100%;
            width: 56px;
            height: 49px;
            position: absolute;
            right: 200px;
            top: 60px;
        }

        .r-reg-cnt {
            width: 568px;
            height: 423px;
            background-color: #000000;
            position: absolute;
            left: 103px;
            top: 213px;
        }

    }

    .reg-swiper {
        .swiper-slide {
            height: calc(100% + 1px) !important;
            overflow: auto;
        }

        // .swiper-slide:last-child {
        //     height: auto !important;
        // }
    }

    // 轮播
    .swiper-container {
        width: 100%;
        height: 100%;

        // 分页
        .pointEvent {
            pointer-events: none;
        }

        .swiper-pagination-home::before {
            width: 300px;
            height: 738px;
            background: url("../assets/img/common/menu-bg.png") no-repeat center;
            background-size: 100% 100%;
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            left: 21px;
            content: '';
            z-index: -1;
        }

        .swiper-pagination-home {
            z-index: 99;
            left: 0;
            top: 0;
            background-size: 100% 100%;
            transition: all 0.5s;
            transform-origin: left top;
            width: 300px;
            height: 738px;
            top: 50%;
            transform: translate(0, -50%);
            padding-top: 115px;

            .swiper-pagination-bullet-active {
                background: transparent;

            }

            .my-bullet {
                display: flex;
                justify-content: left;
                margin-left: 27px;
                align-items: center;
                height: 76px;

                i {
                    display: block;
                    margin-left: -2px;
                }
            }

            .my-bullet0 i {
                display: block;
                width: 183px;
                height: 24px;
                background: url("../assets/img/common/menu1.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet0.swiper-pagination-bullet-active i {
                background: url("../assets/img/common/menu1-active.png") center top;
                background-size: 100% 100%;
                width: 211px;
                height: 47px;
            }

            // .my-bullet1 i {
            //     display: block;
            //     width: 154px;
            //     height: 24px;
            //     background: url("../assets/img/common/menu2.png") center top;
            //     background-size: 100% 100%;
            // }

            // .my-bullet1.swiper-pagination-bullet-active i {
            //     background: url("../assets/img/common/menu2-active.png") center top;
            //     background-size: 100% 100%;
            //     width: 211px;
            //     height: 47px;
            // }

            .my-bullet1 i {
                display: block;
                width: 129px;
                height: 24px;
                background: url("../assets/img/common/menu3.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet1.swiper-pagination-bullet-active i {
                background: url("../assets/img/common/menu3-active.png") center top;
                background-size: 100% 100%;
                width: 211px;
                height: 47px;
            }

            .my-bullet2 i {
                display: block;
                width: 159px;
                height: 24px;
                background: url("../assets/img/common/menu8.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet2.swiper-pagination-bullet-active i {
                background: url("../assets/img/common/menu8-active.png") center top;
                background-size: 100% 100%;
                width: 211px;
                height: 47px;
            }

            .my-bullet3 i {
                display: block;
                width: 184px;
                height: 24px;
                background: url("../assets/img/common/menu4.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet3.swiper-pagination-bullet-active i {
                background: url("../assets/img/common/menu4-active.png") center top;
                background-size: 100% 100%;
                width: 211px;
                height: 47px;
            }

            .my-bullet4 i {
                display: block;
                width: 159px;
                height: 24px;
                background: url("../assets/img/common/menu5.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet4.swiper-pagination-bullet-active i {
                background: url("../assets/img/common/menu5-active.png") center top;
                background-size: 100% 100%;
                width: 211px;
                height: 47px;
            }

            .my-bullet5 i {
                display: block;
                width: 159px;
                height: 24px;
                background: url("../assets/img/common/menu6.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet5.swiper-pagination-bullet-active i {
                background: url("../assets/img/common/menu6-active.png") center top;
                background-size: 100% 100%;
                width: 211px;
                height: 47px;
            }

            .my-bullet6 i {
                display: block;
                width: 159px;
                height: 24px;
                background: url("../assets/img/common/menu7.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet6.swiper-pagination-bullet-active i {
                background: url("../assets/img/common/menu7-active.png") center top;
                background-size: 100% 100%;
                width: 211px;
                height: 47px;
            }

        }


    }
}

@keyframes loop-scene {
    0% {
        background-position: 0;
    }

    to {
        background-position: -2580px;
    }
}


.btnlist {
    position: absolute;
    right: 24px;
    top: 24px;
    z-index: 2;


    .NaverLoungeIcon {
        background: url("../assets/img/common/naverlounge-icon.png") no-repeat center;
        background-size: 100% 100%;
    }
    .zf {
        background: url("../assets/img/common/icon-zf.png") no-repeat center;
        background-size: 100% 100%;
        width: 97px;
        height: 48px;
        margin-right: 12px;
    }
    .sns {
        background: url("../assets/img/common/sns-icon.png") no-repeat center;
        background-size: 100% 100%;
    }

    .share {
        background: url("../assets/img/common/share-icon.png") no-repeat center;
        background-size: 100% 100%;
    }

    .icon-size {
        width: 48px;
        height: 48px;
        margin-right: 12px;
    }
}

.r-icon-link {
    position: absolute;
    right: 26px;
    top: 270px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;

    .register {
        // background: url("../assets/img/common/register.png") no-repeat center;
        // background-size: 100% 100%;
        width: 176px;
        height: 177px;
        // right: 26px;
        // top: 270px;
    }

    .award {
        background: url("../assets/img/common/award.png") no-repeat center;
        background-size: 100% 100%;
        width: 260px;
        height: 200px;
        margin-top: 100px;
        // top: 550px;
        // right: 26px;

    }

}

@media screen and (min-width: 2560px) and (max-width: 3440px) {

    .r-reg {
        width: 1166px !important;
        height: 646px !important;

        .r-reg-cnt {
            width: 510px !important;
            height: 370px !important;
            background-color: #000000;
            position: absolute;
            left: 88px !important;
            top: 181px !important;
        }
    }

    .swiper-pagination-home::before,
    .swiper-pagination-home {
        width: 255px !important;
        height: 627px !important;
    }

    .swiper-pagination-home {
        .my-bullet0 i {
            width: 150px !important;
            ;
            height: 20px !important;
            ;
            margin-top: 74px;
        }

        .my-bullet1 i {
            width: 131px !important;
            ;
            height: 20px !important;
            ;
            margin-top: 47px;
        }

        .my-bullet3 i {
            width: 110px !important;
            ;
            height: 20px !important;
            ;
            margin-top: 43px;
        }

        .my-bullet4 i {
            width: 156px !important;
            ;
            height: 20px !important;
            ;
            margin-top: 43px;
        }

        .my-bullet5 i {
            width: 135px !important;
            ;
            height: 20px !important;
            ;
            margin-top: 54px;
        }

        .my-bullet6 i,
        .my-bullet2 i {
            width: 135px !important;
            ;
            height: 20px !important;
            ;
            margin-top: 60px;
        }

        .swiper-pagination-bullet-active i {
            width: 180px !important;
            height: 40px !important;
        }
    }

    .register {
        width: 150px !important;
        height: 150px !important;
    }

    .award {
        width: 221px !important;
        height: 170px !important;
    }

}</style>


// WEBPACK FOOTER //
// src/components/MainIndex.vue